var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27_6532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2817 7C12.2817 9.48528 10.267 11.5 7.78174 11.5C5.29646 11.5 3.28174 9.48528 3.28174 7C3.28174 4.51472 5.29646 2.5 7.78174 2.5C10.267 2.5 12.2817 4.51472 12.2817 7Z",
    fill: "#59C381"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.78181 10.0462C9.46416 10.0462 10.828 8.68236 10.828 7.00001C10.828 5.31767 9.46416 3.95386 7.78181 3.95386C6.09947 3.95386 4.73566 5.31767 4.73566 7.00001C4.73566 8.68236 6.09947 10.0462 7.78181 10.0462ZM7.78181 10.8077C9.88474 10.8077 11.5895 9.10294 11.5895 7.00001C11.5895 4.89708 9.88474 3.19232 7.78181 3.19232C5.67888 3.19232 3.97412 4.89708 3.97412 7.00001C3.97412 9.10294 5.67888 10.8077 7.78181 10.8077Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27_6532",
    x: 0.281738,
    y: 0.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_6532"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_6532",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.0f27cf97d59dac7af77f4ec57661f8fd.svg";
export { ForwardRef as ReactComponent };